<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_17">- <strong>PART ONE</strong> -</a></h1><a id="page_17">
</a><h1 class="part-title"><a id="page_17"><em>Becoming a Scholar</em></a><a id="page_18"></a></h1><a id="page_18">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Part01.vue?0f198972